export default class Screening {
  static getScreeningResult() {
    if (window?.API && window.API['screening-results-page']?.result) {
      return window.API.result || window.API['screening-results-page'].result;
    }

    return undefined;
  }

  static getScreeningCurrentDepartment() {
    if (window?.API && window.API['screening-results-page']?.current) {
      return window.API['screening-results-page'].current;
    }
    return '';
  }
}
